<div class="mat-calendar-header">
    <!-- Fiscal Year Selection -->
    <div class="mat-calendar-controls">
        <button mat-icon-button type="button" [disabled]="isFirstIndex" (click)="setPreviousFiscalYear()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <mat-select class="pwo-select selector fy-select" [formControl]="fiscalYearCtrl" [placeholder]="selectionLabel">
            @for (fiscalYear of fiscalYears; track fiscalYear?.label) {
                <mat-option [value]="fiscalYear">
                    {{ ('shared.calendar.abbreviations.fiscal-year' | translate) + ' ' + fiscalYear.label }}</mat-option
                >
            }
        </mat-select>
        <button mat-icon-button type="button" [disabled]="isLastIndex" (click)="setNextFiscalYear()">
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
    </div>

    <!-- Navigation by month / year -->
    <div class="mat-calendar-controls">
        <button mat-icon-button type="button" [disabled]="isPreviousDisabled" (click)="setPreviousPeriod()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <button mat-button type="button" class="mat-calendar-spacer header-label" (click)="currentPeriodClicked()">
            {{ periodLabel }}
            <mat-icon iconPositionEnd>{{ isMonthView ? 'arrow_drop_down' : 'arrow_drop_up' }}</mat-icon>
        </button>
        <button mat-icon-button type="button" [disabled]="isNextDisabled" (click)="setNextPeriod()">
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
    </div>
</div>
